module.exports = __webpack_public_path__ + "img/device.9d658a2b.svg";